'use client';

import { useState, useEffect } from 'react';
import i18n from '@/shared/i18n';

/**
 * Hook to check if i18n is initialized and ready to use
 * Prevents hydration mismatches by delaying render until translations are loaded
 */
export function useI18nReady() {
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    // Check if already initialized
    if (i18n.isInitialized) {
      setIsReady(true);
      return;
    }

    // Wait for initialization
    const handleInit = () => setIsReady(true);
    i18n.on('initialized', handleInit);

    return () => {
      i18n.off('initialized', handleInit);
    };
  }, []);

  return isReady;
}
